// extracted by mini-css-extract-plugin
export default {"table":"Fatture_table__yJ2y+","DesktopOnly":"Fatture_DesktopOnly__wtwMC","MobileOnly":"Fatture_MobileOnly__y+ogb"};